export default function areasService($http, RESOURCES) {
  var areasUrl = '/areas';

  function getAreas(id) {
    return $http.get(RESOURCES.MERCHANT + '/' + id + areasUrl);
  }

  function addArea(id, data, file, type, backgroundFile) {
    var apiVersion = 3;
    var fd = new FormData();
    fd.append('dto', new Blob([angular.toJson(data)], { type: 'application/json' }));
    fd.append('attachment', file);
    if (backgroundFile) {
      apiVersion = 4;
      fd.append('tablePlan', backgroundFile);
    }
    fd.append('attachmentType', new Blob([angular.toJson(type)], { type: 'application/json' }));

    return $http.post(RESOURCES.MERCHANT + '/' + id + areasUrl, fd, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined, 'X-Quandoo-ApiVersion': apiVersion },
    });
  }

  function getArea(merchantId, areaId) {
    return $http.get(RESOURCES.MERCHANT + '/' + merchantId + areasUrl + '/' + areaId);
  }

  function updateArea(merchantId, areaId, data, backgroundFile) {
    var fd = new FormData();
    fd.append('dto', new Blob([angular.toJson(data)], { type: 'application/json' }));
    if (backgroundFile) {
      fd.append('tablePlan', backgroundFile);
    }

    return $http.put(RESOURCES.MERCHANT + '/' + merchantId + '/areas/' + areaId, fd, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined, 'X-Quandoo-ApiVersion': '2' },
    });
  }

  function deleteArea(merchantId, areaId) {
    return $http.delete(RESOURCES.MERCHANT + '/' + merchantId + areasUrl + '/' + areaId);
  }

  return {
    getArea: getArea,
    addArea: addArea,
    getAreas: getAreas,
    updateArea: updateArea,
    deleteArea: deleteArea,
  };
}



// WEBPACK FOOTER //
// ./src/app/merchants/areas/areas.service.js